export default {
  ready: false,
  isLoading: false,
};
